<template>
  <workshop-management
    :add-participant="apis.workshop.addWorkshopParticipant"
    :download-certificate="apis.workshop.downloadWorkshopCertificate"
    :download-file="apis.dashboard.downloadDocumentByAttachmentId"
    :get-all="apis.workshop.getAllWorkshop"
    :get-details="apis.workshop.getWorkshopDetail"
    :get-statuses="apis.workshop.getWorkshopStatuses"
    :last-registered-participant="apis.workshop.getLatestParticipant"
    :redeem="apis.workshop.redeemWorkshop"
    :update-participant-status="apis.workshop.updateParticipantWorkshopStatus"
    :validate-tests="apis.workshop.validateWorkshopTests"
  />
</template>
<script>
import WorkshopManagement from 'workshop-management';
import { extend } from 'vee-validate';
import moment from 'moment';

extend('between-workshop-dates', {
  validate(value, { startDate, endDate }) {
    const dateValue = moment(value).startOf('day');
    const start = moment(startDate).startOf('day');
    const end = moment(endDate).startOf('day');

    return dateValue.isSameOrAfter(start) && dateValue.isSameOrBefore(end);
  },
  params: ['startDate', 'endDate'],
  message: 'La fecha de participación debe estar entre las fechas del taller.',
});

import * as workshopService from '@/services/mipe/dashboard-management';
import dashboard from '@/services/mipe/dashboard';

export default {
  name: 'OperationsWorkshops',
  components: { WorkshopManagement },
  computed: {
    apis() {
      return Object.freeze({
        workshop: workshopService,
        dashboard: dashboard,
      });
    },
  },
};
</script>
<style scoped>
::v-deep(.bg-gray) {
  background-color: unset !important;
}
</style>
